import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Phone, Mail, MapPin, Clock } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-950 text-white pt-16 pb-8" data-id="element-57">
      <div className="container-custom" data-id="element-58">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-59">
          {/* Company Info */}
          <div data-id="element-60">
            <div className="flex flex-col mb-6" data-id="element-61">
              <span className="text-2xl font-bold text-white tracking-tight leading-none" data-id="element-62">
                Brixen
              </span>
              <span className="text-xs font-medium text-blue-400 tracking-widest uppercase mt-0.5" data-id="element-63">
                Consulting
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-64">
              Structured, compliant, and execution-focused solutions for
              companies operating in the UAE and internationally.
            </p>
            <div className="flex space-x-4" data-id="element-65">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-66">
                <Linkedin className="h-5 w-5" data-id="element-67" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-68">
                <Twitter className="h-5 w-5" data-id="element-69" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-70">
                <Instagram className="h-5 w-5" data-id="element-71" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-72">
            <h3 className="text-lg font-semibold mb-6" data-id="element-73">Quick Links</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-74">
              <li data-id="element-75">
                <Link to="/" className="hover:text-blue-400 transition-colors" data-id="element-76">
                  Home
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-id="element-78">
                  About Us
                </Link>
              </li>
              <li data-id="element-79">
                <Link to="/industries" className="hover:text-blue-400 transition-colors" data-id="element-80">
                  Industries
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/contact" className="hover:text-blue-400 transition-colors" data-id="element-82">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-83">
            <h3 className="text-lg font-semibold mb-6" data-id="element-84">Services</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-85">
              <li data-id="element-86">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-87">
                  Corporate Services
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-89">
                  Commercial Brokerage
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-91">
                  Investment Management
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/services" className="hover:text-blue-400 transition-colors" data-id="element-93">
                  Business Setup
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-94">
            <h3 className="text-lg font-semibold mb-6" data-id="element-95">Contact Us</h3>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-96">
              <li className="flex items-start" data-id="element-97">
                <MapPin className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-98" />
                <span data-id="element-99">
                  DSO-IFZA, IFZA Properties, Dubai Silicon Oasis, Dubai, UAE
                </span>
              </li>
              <li className="flex items-center" data-id="element-100">
                <Phone className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-101" />
                <a href="tel:+971042766249" className="hover:text-white transition-colors" data-id="element-102">
                  +971 04 276 6249
                </a>
              </li>
              <li className="flex items-center" data-id="element-103">
                <Mail className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-104" />
                <a href="mailto:info@brixenconsulting.com" className="hover:text-white transition-colors" data-id="element-105">
                  info@brixenconsulting.com
                </a>
              </li>
              <li className="flex items-center" data-id="element-106">
                <Clock className="h-5 w-5 mr-3 text-blue-500 shrink-0" data-id="element-107" />
                <span data-id="element-108">Mon–Fri, 9:00 AM – 6:00 PM (GST)</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8" data-id="element-109">
          <p className="text-xs text-gray-500 text-center mb-6 leading-relaxed max-w-4xl mx-auto" data-id="element-110">
            Brixen Consulting FZCO provides corporate services, business
            support, and commercial brokerage/introduction services. We do not
            provide regulated financial advice, banking services, or legal
            advice. Where applicable, services are subject to relevant
            approvals, third-party requirements, and UAE regulations.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-500" data-id="element-111">
            <p data-id="element-112">
              &copy; {currentYear} Brixen Consulting FZCO. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-113">
              <Link to="/terms" className="hover:text-white transition-colors" data-id="element-114">
                Terms & Conditions
              </Link>
              <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-115">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}